import React from 'react';
import { getFullUrl } from '../../../../utils/url';

interface SwapAvatarProps {
  name: string;
  imageUrl?: string | null;
  // Size (and any extra) classes. Defaults to the swap-card size; pass e.g. "h-8 w-8"
  // for the denser picker rows.
  className?: string;
}

// Shared avatar for the Shift Swaps surface: an employee photo with a tinted-initial
// fallback. Used by the swap card, the shift picker, and the colleague picker so the
// same person renders identically everywhere.
const SwapAvatar: React.FC<SwapAvatarProps> = ({ name, imageUrl, className = 'h-9 w-9' }) => {
  const url = getFullUrl(imageUrl || undefined);
  return (
    <div
      className={`${className} shrink-0 overflow-hidden rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold`}
    >
      {url ? (
        <img src={url} alt={name} className="h-full w-full object-cover" />
      ) : (
        (name || '?').charAt(0).toUpperCase()
      )}
    </div>
  );
};

export default SwapAvatar;
